/** Check if a something is undefined. Used when doing conditional imports */
export function isUndefined(obj: any) {
  return typeof obj === 'undefined';
}
